module.exports = __webpack_public_path__ + "img/panda_playlist_icon.72220611.svg";